import React, { useEffect, useState } from "react";

import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import moment from "moment";
import currencyFormatter from "currency-formatter";
import instance from "../../../WebApi/WebApi";

const PurchaseHistoryModal = ({ selectedProductId, show, onHide }) => {
  const { t } = useTranslation();

  const [purchaseHistories, setPurchaseHistories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (show) {
      setPurchaseHistories([]);
      if (selectedProductId) {
        fetchPurchaseHistory(selectedProductId);
      }
    }
  }, [show, selectedProductId]);

  const fetchPurchaseHistory = async (productId) => {
    console.log("Modal Called");

    try {
      const response = await instance.get(
        `/customer/product/get-product-details-by-id?productId=${productId}`
      );

      if (response?.data?.status !== 200) {
        toast.error("Purchase History not found!");
      } else {
        setPurchaseHistories(response?.data?.data?.purchaseHistories);
      }
    } catch (err) {
      toast.error("Something went wrong while fetching history");
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      dialogClassName="custom-modal-size"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4 className="mb-3">{t("purchaseHistory")}</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dbMaintable respTable">
          <table>
            <thead>
              <tr>
                <th>{t("orderId")}</th>
                <th>{t("Invoice Id")}</th>
                <th>{t("Date")}</th>
                <th>{t("User")}</th>
                <th>{t("productNumber")}</th>
                <th>{t("productName")}</th>
                <th>{t("Purchase Quantity")}</th>
                <th>{t("Price")}</th>
                <th>{t("Change Percentage")}</th>
              </tr>
            </thead>

            <tbody>
              {purchaseHistories.length > 0 ? (
                purchaseHistories.map((purchaseHistory) => (
                  <tr key={purchaseHistory.id}>
                    <td data-label={t("orderId")}>
                      <Link
                        to={`/pastorderedit?id=${purchaseHistory?.pastOrder?.id}&invoiceId=${purchaseHistory?.invoiceId}`}
                        target="_blank"
                        className="text-primary"
                        title={t("viewOrderDetails")}
                      >
                        <i className="fa-solid fa-up-right-from-square me-1"></i>
                        {purchaseHistory?.pastOrder?.id || "-"}
                      </Link>
                    </td>
                    <td data-label={t("orderId")}>
                      <Link
                        to={`/invoicedetails?id=${purchaseHistory?.pastOrder?.orginalInvoiceId}&orderId=${purchaseHistory?.pastOrder?.id}&invoiceId=${purchaseHistory?.pastOrder?.id}`}
                        target="_blank"
                        className="text-primary"
                        title={t("viewOrderDetails")}
                      >
                        <i className="fa-solid fa-up-right-from-square me-1"></i>
                        {purchaseHistory?.pastOrder?.pastOrderId || "-"}
                      </Link>
                    </td>
                    <td data-label={t("Order Date")}>
                      {moment(
                        purchaseHistory?.pastOrder?.deliveryDateTime
                      ).format("DD-MM-YYYY")}
                    </td>
                    <td data-label={t("User")}>
                      {`${purchaseHistory?.User?.firstName || ""} ${
                        purchaseHistory?.User?.lastName || ""
                      }`}
                    </td>
                    <td data-label="Product Number">
                      {purchaseHistory?.Product?.item?.Item
                        ?.SellersItemIdentification?.ID?._text ? (
                        <Link
                          to={`/productdetails?id=${purchaseHistory?.Product?.id}`}
                          target="_blank"
                          className="text-primary"
                          title="View Order Details"
                        >
                          <i className="fa-solid fa-up-right-from-square me-1"></i>
                          {`${
                            purchaseHistory?.Product?.item?.Item
                              ?.SellersItemIdentification?.ID?._text || "-"
                          }`}
                        </Link>
                      ) : (
                        <span>-</span>
                      )}
                    </td>
                    <td data-label="Product Name">
                      {`${
                        purchaseHistory?.Product?.item?.Item?.Name?._text || "-"
                      }`}
                    </td>
                    <td data-label={t("Purchase Quantity")}>
                      {purchaseHistory?.Product?.item?.InvoicedQuantity
                        ?._text || "-"}
                    </td>
                    <td data-label={t("Price")}>
                      {purchaseHistory?.currencyType || ""}{" "}
                      {currencyFormatter
                        .format(Number(purchaseHistory?.baseUnitPrice || 0), {
                          code: "ISK",
                          precision: 2,
                        })
                        .replace("kr.", "")
                        .trim()}
                    </td>
                    <td data-label="Change In Percentage">
                      <span
                        className={
                          purchaseHistory.changePercentage > 0
                            ? "text-danger fw-500"
                            : purchaseHistory.changePercentage < 0
                            ? "text-success fw-500"
                            : ""
                        }
                      >
                        {purchaseHistory.changePercentage > 0
                          ? `+${purchaseHistory.changePercentage.toFixed(2)}%`
                          : `${purchaseHistory.changePercentage.toFixed(2)}%`}
                      </span>
                    </td>
                  </tr>
                ))
              ) : isLoading ? (
                <tr>
                  <td colSpan="10" className="text-center">
                    <i className="fa-solid fa-spinner fa-spin text-success fs-4"></i>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    {t("noPurchaseHistoryFound")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PurchaseHistoryModal;
